import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Checkbox, FormField, Modal, Select, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiFileExcel, mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import { format, parse } from 'date-fns';
import BadgeUserType from '../../../../../components/extras/BadgeUserType';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import SelectUserType from '../../../../../components/selects/selectUserTypes';
import TableMovements from '../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemsMovement } from '../../../../../resources/types';
import { buildBreadcrumbItems, exportToExcel, formatCurrency, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';


interface ReportItem {
    idUser: number;
    displayName: string;
    idUserType: number;
    balance: number;
}
export const ReportsFinancesBalancesPage = () => {
    const { menu, parameters } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();
    const [movements, setMovements] = useState<ItemsMovement[]>();



    const [users, setUsers] = useState<ReportItem[]>([]);
    const [includeInactive, setIncludeInactive] = useState<number>(0);
    const [filteringText, setFilteringText] = useState("");
    const [type, setType] = useState({ label: "Solo deudores", value: "NEGATIVE" });
    const [idUserTypes, setIdUserTypes] = useState<number[]>([]);


    const [sortingColumn, setSortingColumn] = useState<any>({ sortingField: "displayName" });
    const [isDescending, setIsDescending] = useState(false);
    const tableRef = useRef(null);



    const handleGetReport = async () => {

        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/reports/finance/balances',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    date: format(parse(`${parameters.period}-01`, 'yyyy-MM-dd', new Date()).toISOString(), 'dd-MM-yyyy'),
                    type: type.value,
                    idUserTypes: idUserTypes,
                    includeInactive: includeInactive,
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.users) {
                setUsers(data.users);
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const filtered = useMemo(() => {
        let result = users;

        // 1. Filtering Logic
        if (filteringText.trim()) {
            const terms = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
            result = result.filter(item => {
                const haystack = [
                    item.displayName ?? "",
                    item.idUser ?? "",
                    item.idUserType.toString(),
                ].join(" ").toLowerCase();

                return terms.every(term => haystack.includes(term));
            });
        }

        return result;
    }, [users, filteringText]);
    const columns = useMemo(() => [

        {
            id: 'displayName',
            header: 'Usuario',
            sortingField: 'displayName',
            cell: (item: any) => item.displayName
        },
        {
            id: 'idUserType',
            sortingField: 'idUserType',
            header: 'Tipo',
            cell: (item: any) => <BadgeUserType idUserType={item.idUserType} type="min" />,
        },
        {
            id: 'balance',
            header: 'Saldo',
            sortingField: 'balance',
            cell: (item: any) => formatCurrency(item.balance, "CLP"),
        },

    ], [users])
    const sortedReport = useMemo(() => {
        const data = [...users];
        const { sortingField } = sortingColumn;

        const columnDefinition = columns.find(col => (col as any).sortingField === sortingField) as any;
        const comparator = columnDefinition?.sortingComparator;

        data.sort((a, b) => {
            let result = 0;
            if (comparator) {
                result = comparator(a, b);
            } else if (sortingField) {
                const valA = a[sortingField as keyof ReportItem];
                const valB = b[sortingField as keyof ReportItem];

                // Check if both values are numbers
                if (typeof valA === 'number' && typeof valB === 'number') {
                    result = valA - valB;
                } else {
                    // Fallback for strings
                    const strA = (valA ?? "").toString().toLowerCase();
                    const strB = (valB ?? "").toString().toLowerCase();
                    result = strA.localeCompare(strB);
                }
            }
            return isDescending ? -result : result;
        });

        return data;
    }, [sortingColumn, isDescending, columns]);

    const handleExcel = () => {
        exportToExcel(users, `radiografia_financiera_${parameters.period}.xlsx`);
    }
    useEffect(() => {
        //handleGetDuplicates();
    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />} description="De cuenta socios">Resumen de saldos</Header>
                    <SpaceBetween size="s" direction="horizontal">
                        <FormField label="Fecha de corte">
                            <MPModal date={parameters.period}
                                end={new Date()}
                                onConfirm={(date) => {
                                    setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                }}
                            />
                        </FormField>
                        <FormField label="Filtro">

                            <Select options={[
                                { "label": "Solo deudores", "value": "NEGATIVE" },
                                { "label": "Todos", "value": "ALL" },
                            ]}
                                onChange={({ detail }) => {
                                    setType({ value: detail.selectedOption.value, label: detail.selectedOption.label });
                                }}

                                selectedOption={type}
                            />
                        </FormField>
                        <FormField label="Tipo de usuario">
                            <SpaceBetween direction="vertical" size="xs">
                                <SelectUserType
                                    value={idUserTypes}
                                    tokenLimit={0}
                                    single={false} onSelect={(e) => {
                                        setIdUserTypes(e);
                                    }} />

                                <Checkbox checked={includeInactive === 1} onChange={(detail) => setIncludeInactive(detail.detail.checked ? 1 : 0)}>Incluir inactivos</Checkbox>
                            </SpaceBetween>

                        </FormField>
                        <FormField label="&nbsp;">
                            <Button style={{ root: btnIconForm }}
                                onClick={() => {
                                    handleGetReport();
                                }}
                            ><Icon path={mdiMagnify} size={1} /></Button>
                        </FormField>
                    </SpaceBetween>

                    <Table
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <FormField label="Buscar">
                                    <TextFilter filteringPlaceholder="Filtrar por usuario" filteringText={filteringText} onChange={(e) => {
                                        setFilteringText(e.detail.filteringText)
                                    }}
                                        disabled={users.length === 0}
                                    />
                                </FormField>
                                <FormField label="&nbsp;">
                                    <Button style={{ root: btnIconForm }} disabled={users.length === 0} onClick={() => handleExcel()}><Icon path={mdiFileExcel} size={1} /></Button>
                                </FormField>
                            </SpaceBetween>
                        }
                        variant='embedded'
                        stickyHeader={true}
                        ref={tableRef}

                        columnDefinitions={columns}
                        items={sortedReport} // Pass the SORTED list here
                        sortingColumn={sortingColumn}
                        sortingDescending={isDescending}
                        onSortingChange={(e) => {
                            setSortingColumn(e.detail.sortingColumn);
                            setIsDescending(e.detail.isDescending);
                        }}
                        loadingText="Cargando saldos..."
                    />

                    <Modal size="large" visible={!!movements} onDismiss={() => setMovements(undefined)} closeAriaLabel="Close modal"
                        header={<Header variant="h2">Movimientos últimos 3 meses</Header>}
                    >
                        <TableMovements movements={movements || []} visible={true}
                            dateFilter="NONE" refresh={false} showUser={false}

                        />

                    </Modal>
                </SpaceBetween >
            }
        />
    );
};
